import { create } from 'zustand';
import type { ArenaRoom } from '../net/client';

export type ConnectionStatus = 'idle' | 'connecting' | 'connected' | 'reconnecting';

interface SessionState {
  status: ConnectionStatus;
  room: ArenaRoom | null;
  /** Last join/connection failure, shown on the home screen. */
  error: string | null;
  /**
   * The last room answered `botError: unavailable` (bot service off or unreachable). The home
   * screen shows a hint next to Play vs Bots; cleared when the next room is joined.
   */
  botsUnavailable: boolean;
}

export const useSessionStore = create<SessionState>(() => ({
  status: 'idle',
  room: null,
  error: null,
  botsUnavailable: false,
}));
